<template>
    <b-container>
        <b-row class="justify-content-center">

            <loading v-if="loading || isRequestSending" />

            <b-card bg-variant="light w-75 mt-3" v-if="!loading && !isRequestSending && getnonDeliveryPostStatus === ''">

                <b-form @submit.prevent="send">

                    <label for="topicId"><b-icon-check-circle class="mr-2" />{{$t('Reason')}}:</label>
                    <b-form-select id="topicId"
                                   v-model="topicId"
                                   :options="getNonDeliveryReasons"
                                   :plain="true"
                                   :state="topicId > -1"
                                   required>
                    </b-form-select>

                    <label for="non-deliveryBody" class="mt-3"><b-icon-inbox-fill class="mr-2" />{{$t('Message')}}</label>
                    <b-textarea id="non-deliveryBody"
                                :state="nonDeliveryBody.length <=255"
                                style="height:130px"
                                v-model="nonDeliveryBody"
                                required>
                    </b-textarea>

                    <div class="justify-content-center mt-2">
                        <b-button to="/">{{$t('Back')}}</b-button>
                        <b-button type="submit" variant="success" class="ml-2">{{$t('Send')}}</b-button>
                    </div>
                </b-form>
            </b-card>
        </b-row>
    </b-container>
</template>

<style>
    .home {
        display: flex;
        align-items: center;
        flex-direction: column;
    }
</style>

<script>
    import { mapGetters } from "vuex";
    import { NONDELIVERYPOST_REQUEST, CLEARNONDELIVERYPOSTSTATUS } from "actions/nonDelivery";

    export default {
        name: "NonDelivery",
        data() {
            return {
                topicId: -1,
                nonDeliveryBody: "",
                TripLineId: this.$store.getters.getOrderById(this.$attrs.id).TripLineId,
            };
        },
        watch: {
            getnonDeliveryPostStatus: function (val) {
                if (val === "success") {
                    this.$root.$children[0].$refs.requestToats.makeToast('success', this.$t('NonDeliverySucTitle'), this.$t('NonDeliverySucBody'));
                    this.$store.commit(CLEARNONDELIVERYPOSTSTATUS);
                    this.$router.push("/");
                }
                if (val === "error") {
                    this.$root.$children[0].$refs.requestToats.makeToast('danger', this.$t('NonDeliveryErrTitle'), this.$t('NonDeliveryErrBody'));
                    this.$store.commit(CLEARNONDELIVERYPOSTSTATUS);
                    this.$router.push("/");
                }
            }
        },
        computed: {
            ...mapGetters(["getNonDeliveryReasons", "getnonDeliveryReasonsStatus", "getnonDeliveryPostStatus"]),
            loading: function () {
                return this.getnonDeliveryReasonsStatus === "loading";
            },
            isRequestSending: function () {
                return this.getnonDeliveryPostStatus === "loading";
            }
        },
        methods: {
            send: function () {
                const data = {
                    reasonId: this.topicId,
                    TripLineId: this.TripLineId,
                    nonDeliveryBody: this.nonDeliveryBody,
                    ShipmentId: this.$attrs.id
                };

                if (this.isOnline)
                    this.$store.dispatch(NONDELIVERYPOST_REQUEST, data);
                else
                    this.$root.$children[0].$refs.requestToats.makeToast('warning', 'no internet connection', 'You are using app in offline mode');
            }
        }
    };
</script>

